import { orchestrator } from 'satcheljs';
import { drawerPaneClosed } from 'owa-drawer';
import { headerButtons } from '../components/buttons/headerButtons';
import closeHeaderPane from './closeHeaderPane';

orchestrator(drawerPaneClosed, ({ paneId, targetWindow }) => {
    const headerButton = headerButtons.find(button => button.pane?.id === paneId);

    if (headerButton) {
        closeHeaderPane(paneId, targetWindow, true /* wasDrawerPaneClosed */);
    }
});
